<!-- Tabela de Titulos -->
<p-table [value]="despesas" [loading]="loading"
  [tableStyle]="{ 'width': '100%' }"
  [responsive]="true"
  [breakpoint]="'960px'"
  [scrollable]="true"
  scrollDirection="horizontal"
  [customSort]="true"
  (onSort)="onSort($event)">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="nomePessoa">{{ labels.pessoa }} <p-sortIcon field="nomePessoa"></p-sortIcon></th>
      <th>{{ labels.numero_titulo }}</th>
      <th pSortableColumn="vencimento">{{ labels.vencimento }} <p-sortIcon field="vencimento"></p-sortIcon></th>
      <th class="text-center">{{ labels.status }}</th>
      <th>{{ labelRegistro }}</th>
      <th class="text-right" pSortableColumn="valor">{{ labelPagoRecebido }} <p-sortIcon field="valor"></p-sortIcon></th>
      <th class="text-right">{{ labels.devolvido }}</th>
      <th class="text-right">{{ labels.saldo }}</th>
      <th class="text-right">{{ labels.valor_total }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr class="row-clicavel" (click)="onTituloClick(item)">

      <!-- 1. Pessoa -->
      <td>
        <span class="titulo-pessoa-nome">{{ item.nomePessoa || '-' }}</span>
      </td>

      <!-- 2. N Titulo -->
      <td>
        <span class="titulo-numero">#{{ item.codigoTitulo || item.numeroParcela || item.id }}</span>
      </td>

      <!-- 3. Vencimento -->
      <td>
        <span class="vencimento-cell">
          <i class="pi pi-calendar"></i>
          {{ formatarVencimento(item.vencimento) }}
        </span>
      </td>

      <!-- 4. Status -->
      <td class="text-center">
        <span class="badge badge-aberto" *ngIf="isAberto(item)">{{ labels.aberto }}</span>
        <span class="badge badge-pago" *ngIf="isPago(item)">{{ labels.pago_status }}</span>
        <span class="badge badge-devolvido" *ngIf="hasDevolvido(item)">{{ labels.devolvido }}</span>
        <span class="badge badge-cancelado" *ngIf="isCancelado(item)">{{ labels.cancelado }}</span>
      </td>

      <!-- 5. Registro de Pagos/Recebidos -->
      <td>
        <div class="pagamento-registro" *ngIf="item.tipoDeCobranca && item.tipoDeCobranca.length > 0; else semRegistro">
          <div class="registro-linha" *ngFor="let pag of item.tipoDeCobranca">
            <span class="registro-data">{{ formatarVencimento(pag.emissaoMovimento || '') }}</span>
            <span class="registro-valor">
              {{ formatarValor((pag.valorMovimento || pag.valor), item.moeda) }}
            </span>
          </div>
        </div>
        <ng-template #semRegistro>
          <span class="texto-vazio">-</span>
        </ng-template>
      </td>

      <!-- 6. Pago/Recebido -->
      <td class="text-right">
        <span class="valor-verde">
          {{ formatarValor(calcularTotalPago(item), item.moeda) }}
        </span>
      </td>

      <!-- 7. Devolvido -->
      <td class="text-right">
        <span class="valor-vermelho">
          {{ formatarValor((item.valorDevolvido || 0), item.moeda) }}
        </span>
      </td>

      <!-- 8. Saldo -->
      <td class="text-right">
        <span class="valor-amarelo">
          {{ formatarValor(item.saldo, item.moeda) }}
        </span>
      </td>

      <!-- 9. Valor Total -->
      <td class="text-right">
        <span class="valor-total-cell">
          {{ formatarValor(item.valor, item.moeda) }}
        </span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="9" class="empty-message-container">
        <div class="empty-state">
          <i class="pi pi-inbox empty-state-icon"></i>
          <p>{{ labels.nenhum_resultado }}</p>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="loadingbody">
    <tr>
      <td [attr.colspan]="9" class="text-center p-5">
        <div class="flex justify-content-center align-items-center">
          <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- Paginacao -->
<div class="pagination-container" *ngIf="totalRecords > 0">
  <div>
    <p-paginator
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} de {totalRecords}"
      [showFirstLastIcon]="true"
      (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>
  <div class="flex align-items-center">
    <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
    <p-dropdown [options]="pageSizeOptions" optionLabel="label"
      optionValue="value" [(ngModel)]="rows"
      (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
    </p-dropdown>
  </div>
</div>
